import type BaseItemId from 'owa-service/lib/contract/BaseItemId';
import type ConversationItem from 'mini-mail-list-store/lib/store/schema/ConversationItem';
import type ConversationType from 'owa-service/lib/contract/ConversationType';
import type ItemId from 'owa-service/lib/contract/ItemId';
import type TableQuery from 'mini-mail-list-store/lib/store/schema/TableQuery';

function mapBaseItemIdsToItemIds(baseItemIds: BaseItemId[]): string[] {
    const itemIds: string[] = [];
    for (const baseItemId of baseItemIds) {
        const itemId: ItemId = { ...baseItemId } as ItemId;
        itemIds.push(itemId.Id);
    }
    return itemIds;
}

export default function mapConversationTypeToConversationItem(
    conversationType: ConversationType,
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars --
     * See aka.ms/mini-lint-errors
     *	> 'tableQuery' is defined but never used. */
    tableQuery: TableQuery
): ConversationItem {
    const itemIds = mapBaseItemIdsToItemIds(conversationType.GlobalItemIds);

    const conversationItem: ConversationItem = {
        id: conversationType.ConversationId.Id,
        subject: conversationType.ConversationTopic,
        recipients: null,
        globalItemIds: itemIds,
        globalLikeCount: conversationType.GlobalLikeCount,
    };

    return conversationItem;
}
